import isNil from 'lodash/isNull';
import isUndefined from 'lodash/isUndefined';
import isString from 'lodash/isString';
import Cookies from 'universal-cookie';
import ApiService from '../ApiService.js';
import { decodeJwt } from '../../Global/JwtDecode';
import SocieteServices from './SocieteServices.js';
import { capitalize } from 'lib/outilsForms';


class AuthService {
  static isLogged() {
    let token = AuthService.getToken();
    return (token !== '' && AuthService.isAuth());
  }
  static isAuth(){
    return ApiService.get("auth/tokenisvalide","",AuthService.getToken())
  }

  static getToken() {
    let token = localStorage.getItem('token');
    if(isNil(token) || isUndefined(token) || token === '') {
      const cookies = new Cookies();
      token = cookies.get('token');
      if(isNil(token) || isUndefined(token) || token === '') {
        return '';
      }
    }
    return token;
  }


  static getRememberMe() {
    let rememberMe = localStorage.getItem('rememberMe');
    if(isNil(rememberMe) || isUndefined(rememberMe) || rememberMe === '') {
      const cookies = new Cookies();
      rememberMe = cookies.get('rememberMe');
      if(isNil(rememberMe) || isUndefined(rememberMe) || rememberMe === '') {
        return  0;
      }
    }
    return rememberMe;
  }
  static getIDUser() {
    let token = this.getToken();
    if(token==='') 
      return 0;
    const decodeToken=decodeJwt(token);
    const current_societe=decodeToken.user.id;
    
    return current_societe;
  }
  static getAccesProduct() {
    let token = this.getToken();
    if(token==='') 
      return 0;
    const decodeToken=decodeJwt(token);
    const accesProduct=decodeToken.user.accesProduct;
    
    return accesProduct;
  }
  static getNameUser() {
    let token = this.getToken();
    if(token==='') 
      return 0;
    const decodeToken=decodeJwt(token);
    const current_societe=capitalize(decodeToken.user.prenom)+" "+capitalize(decodeToken.user.nom);
    return current_societe;

  }
  
  static getLevelAdmin() {
    let token = this.getToken();
    if(token==='') 
      return 0;
      
      const decodeToken=decodeJwt(token);
      const currentAdmin=decodeToken.user.levelAdmin;
      return currentAdmin;
  }
  static AuthoriseToCreateAccount() {
    return (AuthService.getLevelAdmin()===0 &&AuthService.isLogged())
  }

  static signIn(email, password, rememberMe = 1) {
    return ApiService.signIn(email, password)
      .then(res => {
        if(isString(res.Result.token)){
          // const decode_value=decodeJwt
          try {
            localStorage.setItem('rememberMe', rememberMe);
            localStorage.setItem('token', res.Result.token);
          } catch(e) {
            console.log("error save to LocalStorage")
          }
          // try {
          //   this.setTokenCookie(res.Result.token, rememberMe);
          // } catch(e) {
          //   console.log("error save to Cookies")
          // }
          return true;
        }
        throw new Error("Invalid value")
      })
      .catch(error => {
        throw error;
      })
  }

  static signUp(email, password,nom,prenom,societes,adminLevel,accesProduct) {
    return ApiService.post("auth/signup",{email, password,nom,prenom,societes,adminLevel,accesProduct},"")
      .then(res => {
        if(res.status===201){
         return res.id;
      }else{
        return 'false';
      }})
      .catch(error => {
        throw error;
      })
  }

  static setTokenCookie(token, rememberMe) {
    const cookies = new Cookies();
    let options = {};
    if(rememberMe) {
      options.maxAge = 30 * 86400;
    }
    cookies.set('token', token, options);
    cookies.set('rememberMe', rememberMe, options);
    return true;
  }


  static logOut() {
    try {
      localStorage.removeItem('token');
      localStorage.removeItem('rememberMe');
      localStorage.removeItem('societe');
      localStorage.removeItem('usedsociete');
    } catch (e) {
      console.log(e);
      return false;
    }
    return true;
  }
  static logOutSociete() {
    try {
     
      localStorage.removeItem('societe');
      localStorage.removeItem('usedsociete');
      
    } catch (e) {
      console.log(e);
    }
    // try {
    //   const cookies = new Cookies();
    //   cookies.remove('societe');
    //   cookies.remove('usedsociete');
    // } catch (e) {
    //   console.log(e);
    // }
    return true;
  }



  static getAllByAdminId(societeid){
    return ApiService.post("auth/getAllByAdminId",{adminLevel:SocieteServices.getAdminLevelFromAuth(),societeSelect:societeid})
    .then(res=>{
      return res;
    })
    .catch(error=>{
      throw error;
    })
  }
  static getAll(){
    return ApiService.post("auth/GetAll","",AuthService.getToken())
    .then(res=>{
      return res;
    })
    .catch(error=>{
      throw error;
    })
  }
  static getById(id){
    return ApiService.post("auth/getByID",{id:id},AuthService.getToken())
    .then(res=>{
      if(res.status===200)return res.idData      ;
      else return 'false'
    })
    .catch(error=>{
      console.log(error)
      return 'false';
    })
  }
  static getAllBySociete(societeid){
    return ApiService.post("auth/getAllBySociete",{societeSelect:societeid},AuthService.getToken())
    .then(res=>{
      return res;
    })
    .catch(error=>{
      throw error;
    })
  }

  static UpdatePasswordbyId(data){
    return ApiService.put("auth/update",data,AuthService.getToken())
    .then(res=>{if(res.status===200)return true 
      else return false 
    })
    .catch(()=>{
      return false;
    })
  }
  static UpdateAdmniSelected(){
    return ApiService.post("auth/UpdateAdminSelect","",AuthService.getToken())
    .then(res=>{
      return res;
    })
    .catch(error=>{
      throw error;
    })
  }
  static getnameid(){
    return ApiService.get("auth/getNameUsers","",AuthService.getToken())
    .then(res=>{
      return res;
    })
    .catch(error=>{
      throw error;
    })
  }
  
}

export default AuthService;



/** WEBPACK FOOTER **
 ** ./src/services/AuthService.js
 **/